export const API_BASE = "http://localhost:8000";
//export const API_BASE = "https://api.projectivetech.com";

export function getJwt() {
  try {
    return typeof window !== "undefined" ? localStorage.getItem("token") : null;
  } catch {
    return null;
  }
}

export function getCsrfToken() {
  try {
    const value = `; ${document.cookie}`;
    const parts = value.split("; csrftoken=");
    if (parts.length === 2) return parts.pop()?.split(";").shift() ?? "";
  } catch {
    return "";
  }
  return "";
}

export async function apiFetch(pathOrUrl, init = {}) {
  const url = pathOrUrl.startsWith("http") ? pathOrUrl : `${API_BASE}${pathOrUrl}`;
  const jwt = getJwt();

  return fetch(url, {
    credentials: "include",
    ...init,
    headers: {
      ...(init.headers || {}),
      ...(jwt ? { Authorization: `Bearer ${jwt}` } : {}),
    },
  });
}

export async function apiGet(path) {
  const response = await apiFetch(path, { method: "GET" });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data?.message ?? data?.error ?? "Request failed");
  return data;
}

export async function apiPost(path, body) {
  const response = await apiFetch(path, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRFToken": getCsrfToken(),
    },
    body: JSON.stringify(body),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data?.error ?? data?.message ?? "Request failed");
  return data;
}
